import { render, staticRenderFns } from "./mallGoods.vue?vue&type=template&id=4045ee53&scoped=true&"
import script from "./mallGoods.vue?vue&type=script&lang=js&"
export * from "./mallGoods.vue?vue&type=script&lang=js&"
import style0 from "./mallGoods.vue?vue&type=style&index=0&id=4045ee53&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045ee53",
  null
  
)

export default component.exports